import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { DEV_ONLY } from '@/config/config';
import enTranslations from './locales/en/translations.json';
import arTranslations from './locales/ar/translations.json';

const savedLang = localStorage.getItem('lang') || 'en';

i18n.use(initReactI18next).init({
  ...(!DEV_ONLY ? { fallbackLng: 'en' } : {}),
  lng: savedLang,
  resources: {
    ar: {
      translations: arTranslations,
    },
    en: {
      translations: enTranslations,
    },
  },
  ns: ['translations'],
  defaultNS: 'translations',
});

i18n.languages = ['en', 'ar'];

export default i18n;
